import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelect from './multiselect'
import {
  setSitesControlPanel,
  setSelectedSitesFilterControlPanel,
  setSelectedAssetsFilterControlPanel,
  setSearchAssetsBySitesFlag,
  setSearchSitesByAssetsFlag,
} from '../../../../store/actions/controlPanel'
import { getSitesByAssetsControlPanel } from '../../../../api/controlPanel'
import { makeQueryApiAssetsSites } from '../../../../utils/productionPanel'
import { setHandleAlert } from '../../../../store/actions/common'

const AssetsFilter = ({ options, placeholder, label }) => {
  const dispatch = useDispatch()
  const [selectedOptions, setSelectedOptions] = useState([])
  const [stateSelectedAssetsList, setStateSelectedAssetsList] = useState('')
  const selectedAssetsList = useSelector(
    (state) => state.controlPanel.selectedAssetsFilter
  )
  const userData = useSelector(({ multitenantUser }) => ({
    accessToken: multitenantUser.accessToken,
    tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  }))
  const assetsBySitesFlag = useSelector(
    (state) => state.controlPanel.assetsBySitesFlag
  )

  const getOptionLabel = (option) => option.fullName

  useEffect(() => {
    setSelectedOptions(selectedAssetsList)
    if (!assetsBySitesFlag) {
      let assetsQuery = makeQueryApiAssetsSites(selectedAssetsList, 'assetsIds')
      setStateSelectedAssetsList(assetsQuery)
    }
  }, [selectedAssetsList])

  useEffect(() => {
    getSitesByAssetsControlPanelFunction(stateSelectedAssetsList)
    if (stateSelectedAssetsList.length === 0) {
      dispatch(setSearchSitesByAssetsFlag(false))
    }
  }, [stateSelectedAssetsList])

  const handleToggleOption = (selectedOptns) => {
    setSelectedOptions(selectedOptns)
    dispatch(setSelectedAssetsFilterControlPanel(selectedOptns))
    dispatch(setSearchSitesByAssetsFlag(true))
  }

  const handleClearOptions = () => {
    setSelectedOptions([])
    dispatch(setSelectedAssetsFilterControlPanel([]))
    dispatch(setSelectedSitesFilterControlPanel([]))
    dispatch(setSearchAssetsBySitesFlag(false))
    dispatch(setSearchSitesByAssetsFlag(false))
  }

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      setSelectedOptions(options)
      dispatch(setSearchSitesByAssetsFlag(true))
      dispatch(setSelectedAssetsFilterControlPanel(options))
    }

    if (!isSelected) {
      handleClearOptions()
    }
  }

  const getSitesByAssetsControlPanelFunction = (assetsQuery) => {
    if (userData?.accessToken) {
      getSitesByAssetsControlPanel(
        userData.accessToken,
        userData.tenantId,
        assetsQuery
      )
        .then((response) => {
          dispatch(setSitesControlPanel(response.data))
          dispatch(setSelectedSitesFilterControlPanel(response.data))
        })
        .catch((error) => {
          console.error(error)
          showAlertMessage('Something wrong happened')
        })
    }
  }

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  return (
    <MultiSelect
      items={options}
      getOptionLabel={getOptionLabel}
      selectedValues={selectedOptions}
      label={label}
      placeholder={placeholder}
      selectAllLabel="Select all"
      onToggleOption={handleToggleOption}
      onClearOptions={handleClearOptions}
      onSelectAll={handleSelectAll}
      id={`assetsFilter`}
    />
  )
}

export default AssetsFilter
